import { dropCursor } from 'prosemirror-dropcursor';
import { gapCursor } from './gapcursor';
export { GapCursorSelection, isGapCursorSelection } from './GapCursorSelection';
export const Cursor = (builder, opts) => {
    builder.addPlugin(() => gapCursor());
    builder.addPlugin(() => dropCursor(opts.dropOptions));
};
